import React, { Component } from 'react'
import moment from "moment"
import { Link } from "react-router-dom"

var checkHours = (num) => {
  let hours = Math.floor(num / 3600);
  return hours
}

var courseTime = (e) => {
  e.preventDefault()
}

const GridCourse = ({ course }) => (
  <div className="col-lg-4 col-sm-6 col-xs-6">
    <div className="single-course">
      <div className="image-box">
        <img src={course.image} alt={course.title} /></div>
      <div className="text">
        {/* <div className="image"><img src={course.image} alt={course.title} /></div> */}
      
        <h5><Link to={`/courses/${course.slug}`} className="tran3s">{course.title}</Link></h5>
        <div className="name clearfix">
            {/* <h6 className="float-left">{course.userName}</h6> */}
        </div>
        <ul className="clearfix">
          <li className="float-left">
            <i className="flaticon-time"></i>
            <a href="#" className="tran3s" onClick={(e) => courseTime(e)}>
            {checkHours(course.duration) ? moment.utc(course.duration * 1000).format('hh:mm:ss') + ' hrs' : moment.utc(course.duration * 1000).format('mm:ss') + ' mins'}
              </a>
          </li>
          <li className="float-right">
          <div className="name  float-right">
          {course.isNewCourse ? <span className="p-bg-color float-right">New</span> : null}
        </div>
          </li>
          {/* <li className="float-left">
                <i className="flaticon-comments"></i>
                <a href="#" className="tran3s">13</a>
              </li> */}
          {/* <li className="float-right">
               {course.isNewCourse?<span className="p-bg-color" style={{padding:'0 1em'}}>New</span>:null}
              </li> */}
        </ul>
      </div>
    </div>
  </div>
)

export default GridCourse 
